(function (angular) {
	'use strict';

	angular
		.module('settingsModule')
		.controller('EditAccreditation', [
			'FileUploadFactory',
			'globalConfig',
			'mixpanelFactory',
			EditAccreditationFunction
		]);

	function EditAccreditationFunction(
		FileUploadFactory,
		globalConfig,
		mixpanelFactory
	) {
		var editAccreditation = this;

		(function init() {
			angular.extend(editAccreditation, globalConfig);

			mixpanelFactory.track('Manage Accreditation Status Shown', { 'Account Type' : editAccreditation.accountType });

			editAccreditation.accreditationLetter = FileUploadFactory.createStateObj('VERIFICATION_DOCUMENTS');
			editAccreditation.resetUpload = FileUploadFactory.resetUpload;
			editAccreditation.uploadFiles = FileUploadFactory.uploadFiles;
		})();
	}
})(window.angular);